export default __webpack_public_path__ + "static/media/diamond-1.62249c45.webp";